<template>
  <div class="base_box">
    <!-- 统计 -->
    <div class="base_content" style="border-radius: 0">
      <div class="total_box">
        <div class="total_item">
          <span class="total_tit">分红池总金额：</span>
          <span class="total_num">￥{{ totalData.total_poolprofit_price || "0.00" }}</span>
        </div>
        <div class="total_item">
          <span class="total_tit">店长分红总额：</span>
          <span class="total_num">￥{{ totalData.total_keeper_price || "0.00" }}</span>
        </div>
        <div class="total_item">
          <span class="total_tit">合伙人分红总额：</span>
          <span class="total_num">￥{{ totalData.total_partner_price || "0.00" }}</span>
        </div>
      </div>
    </div>

    <baseSearch class="mt10" @search="searchFun" @reset="resetFun" :list="searchFrom">
    </baseSearch>

    <div class="mt10 base_content" style="border-radius: 0">
      <!-- 状态标签 -->
      <div class="order_type">
        <div
          @click="changeStatus('')"
          :class="search.post.poolprofit_deposited === '' ? 'order_type_active' : ''"
          class="order_type_item"
        >
          全部
        </div>
        <div
          @click="changeStatus(0)"
          :class="search.post.poolprofit_deposited === 0 ? 'order_type_active' : ''"
          class="order_type_item"
        >
          未到账
        </div>
        <div
          @click="changeStatus(1)"
          :class="search.post.poolprofit_deposited === 1 ? 'order_type_active' : ''"
          class="order_type_item"
        >
          已到账
        </div>
      </div>

      <table class="order_table" border="0" cellspacing="0" cellpadding="0">
        <tr>
          <th align="center" style="width: 320px">商品信息</th>
          <th align="center" style="width: 150px">单价/数量</th>
          <th align="center" style="width: 120px">实付款</th>
          <th align="center" style="width: 180px">买家</th>
          <th align="center" style="width: 170px">下单时间</th>
          <th align="center" style="width: 120px">订单状态</th>
          <th align="center" style="width: 140px">分红状态</th>
          <th align="center" style="width: 180px">分红金额/时间</th>
        </tr>
        <tbody v-if="search.table.length <= 0">
          <tr>
            <td colspan="8" style="padding: 0; border: 0">
              <div class="no_data">暂无数据</div>
            </td>
          </tr>
        </tbody>
        <tbody v-for="(item, index) in search.table" :key="index">
          <tr>
            <td colspan="8" style="padding: 0; border: 0">
              <div class="order_table_head">
              <div style="display: flex; align-items: center; justify-content: space-between; width: 100%">
                <div>
                  <span>订单编号：{{ item.order_no }}</span>
                  <span style="margin-left: 20px">支付时间：{{ item.pay_time || "-" }}</span>
                </div>
                <el-button type="text" size="small" @click="openDetail(item)">查看详情</el-button>
              </div>
              </div>
            </td>
          </tr>
          <tr>
            <!-- 商品信息 -->
            <td align="center">
              <div
                v-if="item.goods && item.goods.length > 0"
                class="commidy_cls"
                style="display: flex; justify-content: center; height: 80px"
                v-for="(gtem, gindex) in item.goods"
                :key="gindex"
              >
                <el-image
                  style="width: 80px; height: 80px; margin-right: 10px; border-radius: 5px"
                  :src="gtem.image ? gtem.image.url : require('@/static/img/people.png')"
                >
                  <div slot="error" style="width: 80px; height: 80px">
                    <img
                      style="width: 80px; height: 80px; border-radius: 5px"
                      src="@/static/img/people.png"
                      alt=""
                    />
                  </div>
                </el-image>
                <div style="text-align: left; flex: 1; width: 200px">
                  <div class="ellipsis2" style="height: 43px; font-size: 14px; width: 200px">
                    {{ gtem.goods_name }}
                  </div>
                  <div style="color: #515a6e; margin-top: 10px; font-size: 13px">
                    <span v-if="gtem.goods_props && gtem.goods_props.length">
                      <span v-for="(ktem, kndex) in gtem.goods_props" :key="kndex">
                        {{ ktem.group.name }}:{{ ktem.value.name }}&nbsp;
                      </span>
                    </span>
                  </div>
                </div>
              </div>
              <div v-else style="text-align: center; color: #999">-</div>
            </td>
            <!-- 单价/数量 -->
            <td align="center">
              <div
                v-if="item.goods && item.goods.length > 0"
                class="commidy_cls"
                style="display: flex; justify-content: center; height: 80px"
                v-for="(gtem, gindex) in item.goods"
                :key="gindex"
              >
                <div style="display: flex; align-items: center; justify-content: center">
                  <div style="color: #000; font-size: 14px">
                    <span>￥{{ gtem.goods_price || "-" }}/ x{{ gtem.total_num || "-" }}</span>
                  </div>
                </div>
              </div>
              <div v-else style="text-align: center; color: #999">-</div>
            </td>
            <!-- 实付款 -->
            <td align="center">
              <strong style="color: #000">￥{{ item.pay_price || "0.00" }}</strong>
            </td>
            <!-- 买家 -->
            <td align="center">
              <div v-if="item.user">
                <div>{{ item.user.nick_name || item.user.true_name || "-" }}</div>
                <div style="font-size: 12px; color: #999; margin-top: 4px">{{ item.user.mobile || "-" }}</div>
              </div>
              <div v-else>-</div>
            </td>
            <!-- 下单时间 -->
            <td align="center">{{ item.created_at || "-" }}</td>
            <!-- 订单状态 -->
            <td align="center" class="order_status">
              <div v-if="item.order_status == '20'">已取消</div>
              <div v-else-if="item.pay_status == '10'">待支付</div>
              <div v-else-if="item.delivery_status == '10'">未发货</div>
              <div v-else-if="item.delivery_status == '30'">部分发货</div>
              <div v-else-if="item.receipt_status == '10'">未收货</div>
              <div v-else-if="item.order_status == '30'">已完成</div>
              <div v-else>{{ item.order_status_name || "-" }}</div>
            </td>
            <!-- 分红状态 -->
            <td align="center">
              <el-tag v-if="item.poolprofit_deposited == 1" type="success" size="small">已到账</el-tag>
              <el-tag v-else type="warning" size="small">未到账</el-tag>
            </td>
            <!-- 分红金额/时间 -->
            <td align="center">
              <div style="text-align: left; display: inline-block">
                <p>分红池：￥{{ item.poolprofit_price || "0.00" }}</p>
                <p>店长：￥{{ item.poolprofit_keeper_price || "0.00" }}</p>
                <p>合伙人：￥{{ item.poolprofit_partner_price || "0.00" }}</p>
                <p v-if="item.poolprofit_time" style="font-size: 12px; color: #999; margin-top: 4px">
                  到账：{{ item.poolprofit_time }}
                </p>
              </div>
            </td>
          </tr>
          <!-- 收货信息 -->
          <tr v-if="item.address">
            <td colspan="8" style="padding: 0; border: 0">
              <div class="order_table_head">
                <span>
                  收件人：{{ item.address.name }}&nbsp;&nbsp;&nbsp;&nbsp;手机号：{{ item.address.phone }}&nbsp;&nbsp;&nbsp;&nbsp;收货地址：
                  {{ item.address.region.province }}{{ item.address.region.city }}{{ item.address.region.region }}{{ item.address.detail }}
                </span>
                <span v-if="item.buyer_remark" style="margin-left: 20px">买家留言：{{ item.buyer_remark }}</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="page_box mt10">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="search.post.page"
          :page-sizes="[15, 30, 50, 100]"
          :page-size="search.post.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="search.total"
        >
        </el-pagination>
      </div>
    </div>

    <detail-modal :visible.sync="modalVisible" :order="detailOrder" @close="modalVisible = false" />
  </div>
</template>

<script>
import baseSearch from "@/components/common/baseSearch";
import detailModal from "./detailModal";
import { eltips } from "@/util/util.js";

export default {
  components: { baseSearch, detailModal },
  data() {
    return {
      totalData: {
        total_poolprofit_price: "0.00",
        total_keeper_price: "0.00",
        total_partner_price: "0.00",
      },
      searchFrom: [
        {
          type: "input",
          Field: "keyword",
          label: "关键字",
          placeholder: "请输入电话、昵称、姓名",
          style: { width: "150px" },
        },
        {
          type: "input",
          Field: "order_no",
          label: "订单号",
          placeholder: "请输入订单号",
          style: { width: "150px" },
        },
        {
          type: "datePicker",
          Field: "created_at",
          label: "支付时间",
          style: { width: "320px" },
        },
        {
          type: "select",
          Field: "poolprofit_deposited",
          label: "分红状态",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "未到账", value: 0 },
            { label: "已到账", value: 1 },
          ],
        },
      ],
      search: {
        post: {
          page: 1,
          limit: 15,
          order_no: "",
          keyword: "",
          poolprofit_deposited: "",
          start_time: "",
          end_time: "",
        },
        total: 0,
        table: [],
      },
      modalVisible: false,
      detailOrder: {},
    };
  },
  created() {
    if (this.$route.query.user_id) {
      this.search.post.keyword = this.$route.query.user_id;
    }
    if (this.$route.query.order_no) {
      this.search.post.order_no = this.$route.query.order_no;
    }
    this.getList();
  },
  methods: {
    // 标签切换
    changeStatus(status) {
      this.search.post.poolprofit_deposited = status;
      this.search.post.page = 1;
      this.getList();
    },
    // 搜索
    searchFun(e) {
      let _this = this;
      _this.search.post.page = 1;
      _this.search.post = { ..._this.search.post, ...e };
      if (e.created_at && e.created_at.length == 2) {
        _this.search.post.start_time = e.created_at[0];
        _this.search.post.end_time = e.created_at[1];
      } else {
        _this.search.post.start_time = "";
        _this.search.post.end_time = "";
      }
      delete _this.search.post.created_at;

      _this.getList();
    },
    // 重置
    resetFun() {
      this.search.post = {
        page: 1,
        limit: 15,
        order_no: "",
        keyword: "",
        poolprofit_deposited: "",
        start_time: "",
        end_time: "",
      };
      this.getList();
    },
    // 查看分红详情
    openDetail(item) {
      this.detailOrder = {
        order_id: item.order_id,
        order_no: item.order_no,
        pay_price: item.pay_price,
        poolprofit_price: item.poolprofit_price,
        poolprofit_time: item.poolprofit_time,
      };
      this.modalVisible = true;
    },
    // 获取列表
    getList() {
      let _this = this;
      let params = { ...this.search.post };
      if (!params.order_no) delete params.order_no;
      if (!params.keyword) delete params.keyword;
      if (params.poolprofit_deposited === "") delete params.poolprofit_deposited;
      if (!params.start_time) delete params.start_time;
      if (!params.end_time) delete params.end_time;

      this.axios
        .get("/api/weishop/admin/plugin/poolprofit/order/index", { params })
        .then((res) => {
          if (res.code == 200) {
            _this.search.table = res.data.data || [];
            _this.search.total = res.data.total || 0;
            _this.totalData.total_poolprofit_price = res.data.total_poolprofit_price || "0.00";
            _this.totalData.total_keeper_price = res.data.total_keeper_price || "0.00";
            _this.totalData.total_partner_price = res.data.total_partner_price || "0.00";
          } else {
            eltips(res.msg, "error");
          }
        });
    },
    handleSizeChange(val) {
      this.search.post.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.search.post.page = val;
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.total_box {
  display: flex;
  padding: 15px 20px;
}
.total_item {
  margin-right: 40px;
}
.total_tit {
  font-size: 14px;
  color: #666;
}
.total_num {
  font-size: 18px;
  color: #000;
  font-weight: 600;
}
.order_type {
  display: flex;
  border-bottom: 1px solid #e9edef;
}
.order_type_item {
  padding: 12px 20px;
  cursor: pointer;
  font-size: 14px;
  color: #666;
  border-bottom: 2px solid transparent;
}
.order_type_active {
  color: #006aff;
  border-bottom-color: #006aff;
}
.order_table {
  width: 100%;
  border-collapse: collapse;
  th {
    background: #f7f8fa;
    padding: 12px 10px;
    font-size: 13px;
    color: #333;
    font-weight: normal;
  }
  td {
    border-bottom: 1px solid #e9edef;
    padding: 12px 10px;
    font-size: 13px;
  }
}
.order_table_head {
  background: #f7f8fa;
  padding: 10px 15px;
  font-size: 13px;
  color: #666;
  display: flex;
  align-items: center;
}
.commidy_cls {
  align-items: center;
}
.no_data {
  padding: 30px;
  text-align: center;
  color: #999;
  width: 100%;
}
.ellipsis2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.order_status {
  color: rgb(0, 106, 255);
}
.page_box {
  text-align: right;
  padding: 15px 20px;
}
</style>
